import { AppState } from '@/store';

export const selectMicEvents = (state: AppState) => state.voiceToSpeech?.logs;
export const selectMicModalOpen = (state: AppState) => state.voiceToSpeech?.modalOpen;
